import {
  PublishParams,
  MusicScheduleFields,
  MusicScheduleListParams,
  MusicScheduleSongs,
} from "../../view/Modules/MusicSchedule/MusicScheduleDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { SongListParams } from "../../view/Modules/Songs/SongDataTypes";

export const MusicScheduleServices = {
  getMusicSchedules: (params: MusicScheduleListParams) => {
    return AxiosInstance.get(ContentApiRoutes.MUSIC_SCHEDULES, { params });
  },
  getMusicScheduleSongs: (id: number, params: SongListParams) => {
    return AxiosInstance.get(
      ContentApiRoutes.MUSIC_SCHEDULE_SONGS.replace(":id", id.toString()),
      { params }
    );
  },
  createMusicSchedule: (data: MusicScheduleFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_MUSIC_SCHEDULE, data),
  updateMusicSchedule: (id: number, data: MusicScheduleFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_MUSIC_SCHEDULE.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  addSongsToMusicSchedule: (id: number, data: MusicScheduleSongs) =>
    AxiosInstance.post(
      ContentApiRoutes.ADD_SONGS_TO_MUSIC_SCHEDULE.replace(
        ":id",
        id.toString()
      ) + "?_method=PUT",
      data
    ),
  deleteSongsFromMusicSchedule: (id: number, data: MusicScheduleSongs) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_SONGS_FROM_MUSIC_SCHEDULE.replace(
        ":id",
        id.toString()
      ) + "?_method=PUT",
      data
    ),
  publishMusicSchedule: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_MUSIC_SCHEDULE.replace(":id", id.toString()),
      data
    ),

  deleteMusicSchedule: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_MUSIC_SCHEDULE.replace(":id", id.toString())
    ),
  deleteTimeSlot: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_TIME_SLOT.replace(":id", id.toString())
    ),
  viewMusicSchedule: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_MUSIC_SCHEDULE.replace(":id", id.toString())
    );
  },

  searchMusicSchedules: (musicSchedule: string) =>
    AxiosInstance.get(
      ContentApiRoutes.MUSIC_SCHEDULES + `?smart_search=${musicSchedule}`
    ),
};
